import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LoginPage: React.FC = () => {
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation() as any;

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  React.useEffect(() => {
    if (isAuthenticated) {
      navigate('/video-creator', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    try {
      await login({ email, password });
      const redirectTo = location.state?.from?.pathname || '/video-creator';
      navigate(redirectTo, { replace: true });
    } catch (err: any) {
      setError(err?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 360, margin: '64px auto', padding: 24, border: '1px solid #ddd', borderRadius: 8 }}>
      <h2>Video-Creator Login</h2>
      <form onSubmit={handleSubmit}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{ width: '100%', padding: 8, marginTop: 4 }}
            />
          </label>
          <label>
            Password
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{ width: '100%', padding: 8, marginTop: 4 }}
            />
          </label>
          {error && <div style={{ color: 'red' }}>{error}</div>}
          <button type="submit" disabled={loading} style={{ padding: '8px 12px' }}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
          <button type="button" onClick={() => navigate('/')} style={{ padding: '8px 12px', background: 'transparent', border: 'none', color: '#1a73e8', cursor: 'pointer' }}>Geri dön</button>
        </div>
      </form>
    </div>
  );
};

export default LoginPage;
